// extracted by mini-css-extract-plugin
module.exports = {"pageIntroText":"PageIntroText_pageIntroText__ML9yS","pageIntroText__container":"PageIntroText_pageIntroText__container__5rpJV"};